import React from 'react';
import { Skeleton } from '../../../../../components/ui/skeleton';
import { TableCell, TableRow } from '../../../../../components/ui/table';

function FileListItemSkeleton() {
  return (
    <TableRow
      data-testid="file-list-skeleton"
      className="border-b border-border/30 hover:bg-transparent bg-white dark:bg-background"
    >
      {/* Name Column - matches FileListItemShell structure */}
      <TableCell className="py-4 px-4">
        <div className="flex items-center gap-3 min-w-0">
          {/* Thumbnail - horizontal aspect ratio like grid view */}
          <Skeleton className="h-9 w-16 rounded flex-shrink-0" />

          {/* Title and Metadata - matches FileListItemShell gap-1 structure */}
          <div className="flex flex-col gap-1 min-w-0 flex-1">
            {/* Title - matches text-sm font-medium */}
            <Skeleton className="h-3.5 w-48 max-w-full" />

            {/* Metadata row - matches text-xs */}
            <Skeleton className="h-3 w-32 max-w-full" />
          </div>
        </div>
      </TableCell>

      {/* Date Column - fixed width, right-aligned */}
      <TableCell className="py-4 px-4 w-32 text-right">
        <Skeleton className="h-3.5 w-24 ml-auto" />
      </TableCell>

      {/* Action Menu Column */}
      <TableCell className="py-4 w-10 pr-4">
        <div className="flex justify-end">
          <Skeleton className="h-6 w-6 rounded opacity-0" />
        </div>
      </TableCell>
    </TableRow>
  );
}

export default FileListItemSkeleton;
